window.Products.HomeDecor.WallTapestry = function() {
};
window.Products.HomeDecor.WallTapestry.inherits(window.Products.HomeDecor.HomeDecor);
window.Products.HomeDecor.WallTapestry.texturesLoading = false;
window.Products.HomeDecor.WallTapestry.texturesLoaded = 0;
window.Products.HomeDecor.WallTapestry.id = 87;
window.Products.HomeDecor.WallTapestry.slug = 'wall-tapestry';
window.Products.HomeDecor.WallTapestry.has_3d = true;
window.Products.HomeDecor.WallTapestry.use_variants = true;
window.Products.HomeDecor.WallTapestry.dpi = 150;
window.Products.HomeDecor.WallTapestry.no_views = true;

window.Products.HomeDecor.WallTapestry.prototype.getFrontMaterial = function(modelViewer) {
	if(!modelViewer || !modelViewer.object || !modelViewer.object.children || !modelViewer.object.children[0]){
		return null;
	}

	var material = modelViewer.object.children[0].material;
	if(Array.isArray(material)){
		material = material[0];
	}

	return material || null;
};

window.Products.HomeDecor.WallTapestry.prototype.set3dProperties = function(modelViewer) {
	var me = this;
	var frontMaterial = me.getFrontMaterial(modelViewer);
	if(!frontMaterial){
		return;
	}

	me.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = 10;
	modelViewer.disableAutoRotate();

	modelViewer.setFixedView('front');

	if(!frontMaterial.map){
		frontMaterial.map = new THREE.Texture();
	}
	frontMaterial.map.offset.x = 1;
	frontMaterial.map.rotation = -Math.PI/2;
	frontMaterial.needsUpdate = true;

	if(!me.texturesLoading && !me.texturesLoaded){
		me.loadTextures(function(){
			var material = me.getFrontMaterial(modelViewer);
			if(!material || !modelViewer.product || !modelViewer.product.textures || !modelViewer.product.textures[0]){
				return;
			}

			if(!material.bumpMap){
				material.bumpMap = new THREE.Texture();
			}

			material.bumpMap.image = modelViewer.product.textures[0].image;
			material.bumpMap.needsUpdate = true;
			material.needsUpdate = true;
		});
	}
};

window.Products.HomeDecor.WallTapestry.prototype.loadTextures = function(callback){
	var product = this;
	var sources = [
		'textures/c_ao.jpg'
	];
	product.texturesLoading = true;
	product.texturesLoaded = 0;
	product.textures = [];
	sources.forEach(function(src, index) {
		var textureLoader = new THREE.TextureLoader();
		textureLoader.crossOrigin = 'anonymous';
		var texture = textureLoader.load(THREE_JSON_URL + src, function(event){
			product.textures[index] = event;
			product.texturesLoaded++;
			if(callback && product.texturesLoaded == sources.length){
				product.texturesLoading = false;
				callback();
			}
		});
	});
};

window.Products.HomeDecor.WallTapestry.prototype.setThreeControls = function(controls){
	controls.minDistance = 1500;
	controls.maxDistance = 2000;
	controls.minPolarAngle = Math.PI/2;
	controls.maxPolarAngle = Math.PI/2;
	controls.minAzimuthAngle = -Math.PI/2.5;
	controls.maxAzimuthAngle = Math.PI/2.5;
};

window.Products.HomeDecor.WallTapestry.prototype.create3dModel = function(modelViewer, variant){
	modelViewer.scene.remove(modelViewer.object);
	modelViewer.object = new THREE.Group();

	var row = 1, col = 1;

	switch(variant) {
		case "landscape":
			row = 17;
			col = 20;
			break;
		case "portrait":
			row = 20;
			col = 17;
			break;
	}

	clothDimensions = [row, col];
	clothPins = [];

	for(var i=0; i<=col; i++){
		clothPins.push(i * (row+1));
	}

	// Corners
	// clothPins = [0, 360];

	// Create model
	var cloth = new ClothSimulator.cloth(clothDimensions[0], clothDimensions[1]);
	var clothFunction = ClothSimulator.getClothFunction(clothDimensions[0], clothDimensions[1]);
	
	var frontGeometry = new THREE.ParametricGeometry(clothFunction, cloth.w, cloth.h);
	frontGeometry.dynamic = true;
	modelViewer.object.frontGeometry = frontGeometry;

	modelViewer.object.add(new THREE.Mesh(frontGeometry, new THREE.MeshPhongMaterial({
		specular: 0x010101,
		map: new THREE.Texture(),
		bumpMap: new THREE.Texture(),
		color: 0xbebebe,
		shininess: 3,
		side: THREE.DoubleSide
	})));

	modelViewer.object.clothSimulator = new ClothSimulator(frontGeometry, clothPins, true);
	modelViewer.object.clothSimulator.cloth = cloth;

	modelViewer.object.rotation.z = Math.PI/2;

	//Set 3D properties specific to Product
	this.set3dProperties(modelViewer);

	// Add model on scene
	modelViewer.scene.add(modelViewer.object);

	//Call back function after object load
	if(typeof modelViewer.onObjectLoad !== 'undefined') {
		modelViewer.onObjectLoad();
	}

	modelViewer.loaded = true;

	modelViewer.onReady();

	// Remove the loader since we're done
	modelViewer.removeLoader();
	if(typeof modelViewer.onLoadDone === "function") modelViewer.onLoadDone();

	// We already know we're gonna be really far so...
	modelViewer.camera.far = 10000;
	modelViewer.camera.updateProjectionMatrix();
};

window.Products.HomeDecor.WallTapestry.prototype.update3dModel = function(modelViewer){
	modelViewer.object.clothSimulator.simulate(modelViewer);

	var p = modelViewer.object.clothSimulator.cloth.particles;

	for (var i = 0, il = p.length; i < il; i ++) {
		modelViewer.object.frontGeometry.vertices[i].copy(p[i].position);
	}

	modelViewer.object.frontGeometry.computeFaceNormals();
	modelViewer.object.frontGeometry.computeVertexNormals();
	modelViewer.object.frontGeometry.normalsNeedUpdate = true;
	modelViewer.object.frontGeometry.verticesNeedUpdate = true;

	modelViewer.camera.lookAt(modelViewer.scene.position);
};

window.Products.HomeDecor.WallTapestry.prototype.updateThreeTexture = function(modelViewer) {
	var frontMaterial = this.getFrontMaterial(modelViewer);
	if(modelViewer && modelViewer.texture && frontMaterial){
		frontMaterial.map = modelViewer.texture;
		modelViewer.texture.flipY = false;
	}

	// Don't ask
	if(modelViewer && modelViewer.camera){
		modelViewer.camera.position.x = 0;
	}
};

window.Products.HomeDecor.WallTapestry.prototype.setThreeView = function(camera, view, zoom) {
	camera.position.x = 0;
};
